import { render, staticRenderFns } from "./AddTarget.vue?vue&type=template&id=70e1630c&"
import script from "./AddTarget.vue?vue&type=script&lang=js&"
export * from "./AddTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports